import { render, staticRenderFns } from "./OrderItemsSelect.vue?vue&type=template&id=4f679e28"
import script from "./OrderItemsSelect.vue?vue&type=script&lang=js"
export * from "./OrderItemsSelect.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsSelect.vue?vue&type=style&index=0&id=4f679e28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports